import React  from 'react';
import styled from 'styled-components';
import { IconCalling } from '../../Assets/contacts/IconCalling';
import { Dictionery } from '../../Data/Dictionery';
import { IconSMS } from '../../Assets/contacts/IconSMS';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconInstagram } from '../../Assets/contacts/IconInstagram';
import { IconFacebook } from '../../Assets/contacts/IconFacebook';
import { IconYoutube } from '../../Assets/contacts/IconYoutube';
import { IconPhone } from '../../Assets/contacts/IconPhone';
const Styles = styled.div`
  margin: 0.5rem 0;
  .over {
    width: calc(100% - calc(var(--universal-pad) * 2) - 5rem);
    margin: 0 var(--universal-pad);
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 2rem 2.5rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    justify-content: space-between;
    gap: 1.25rem;
    .data {
      flex-grow: 1;
      width: 50%;
      display: flex;
      flex-direction: column;
      .row {
        display: flex;
        justify-content: space-between;
        padding: 1rem 0;
        align-items: center;
      }
      .column {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 1rem 0;
      }
      .line-vertical {
        height: 1px;
        background-color: var(--n-grey-1);
      }
      .title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .text {
          font-weight: 600;
          color: var(--n-grey-2);
        }
      }
      .desc {
        white-space: pre-wrap;
        font-weight: 600;
        .socials {
          display: flex;
          justify-content: flex-end;
          gap: 1.25rem;
          .social {
            border-radius: 100px;
            border: 1px solid var(--n-grey-1);
            background-color: var(--n-grey-01);
            padding: 0.87rem;
            svg {
              display: block;
            }
          }
        }
      }
    }
    .image {
      flex-grow: 1;
      width: 50%;
      /* height: 100%; */
      background-color: var(--n-grey-2);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      img {
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .map-item {
    width: calc(100% - calc(var(--universal-pad) * 2));
    margin: 1rem var(--universal-pad);
    background-color: var(--n-grey-0);
    border-radius: var(--border-radius-32);
    overflow: hidden;
    box-shadow: 0px 4px 50px -16px #00000028;
    iframe {
      width: 100%;
      height: 400px;
      display: block;
      outline: none;
      border: none;
    }
  }
  @media screen and (max-width: 850px) {
    .over {
      flex-direction: column;
      width: calc(100% - calc(var(--universal-pad) * 2) - 2rem);
      padding: 2rem 1rem 1rem;
      .data {
        width: 100%;
      }
      .image {
        width: 100%;
        aspect-ratio: 1.5;
      }
    }
  }
`
export default function FullContact12 (props){
  const {data: dataRaw, lan} = props;
  const data = JSON.parse(dataRaw);
  const makeData = (icon, title, data, className) => {
    return (
      <div className={className}>
        <div className='title'>
          {
            (icon) ? (
              <div className='icon'>
                {icon}
              </div>
            ) : ""
          }
          
          <div className='text'>
            {title}
          </div>
        </div>
        <div className='desc'>
          {data}
        </div>
      </div>
    )
  }
  const makeLink = (link, type) => {
    if(link){
      switch(type){
        case "instagram":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconInstagram/>
            </a>
          )
        case "facebook":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconFacebook/>
            </a>
          )
        case "youtube":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconYoutube/>
            </a>
          )
        case "tell":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconPhone/>
            </a>
          )
        default:
          return;
      }
    }
    return;
  }
  return (
    <Styles>
      <pre className='over'>
        <div className='data'>
            {makeData(<IconCalling/>, Dictionery.call[lan.filename], data.tel, "row")}
          <div className='line-vertical'></div>
            {makeData(<IconSMS/>, Dictionery.email[lan.filename], data.email, "row")}
          <div className='line-vertical'></div>
            {makeData(<IconBuilding/>, Dictionery.address[lan.filename], data.address, "column")}
          <div className='line-vertical'></div>
            {makeData(null, Dictionery.communication[lan.filename],(
              <div className='socials'>
                {makeLink(data.telLink, "tell")}
                {makeLink(data.insta, "instagram")}
                {makeLink(data.facebook, "facebook")}
                {makeLink(data.youtube, "youtube")}
              </div>
            ), "row")}
        </div>
        <div className='image'>
          <img src={data.Image} alt='location agency'/>
        </div>
      </pre>
      <div className='map-item'>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3239.0608409985657!2d51.4216389!3d35.72472219999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDQzJzI5LjAiTiA1McKwMjUnMTcuOSJF!5e0!3m2!1sen!2suk!4v1724759185783!5m2!1sen!2suk" 
          // width="800" 
          // height="400" 
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </Styles>
  )
}

